import userManagement from './userManagementReducer';

export default {
  userManagement
};
